define([
  "marionette",
  "jquery",
  "underscore",
  "select2",
  "./template/taskStepsTemplate.html",
  "./template/taskStepTemplate.html",
], function (Marionette, $, _, select2, TaskStepsTemplate, TaskStepTemplate) {
  "use strict";

  var TaskStepsView = {};

  TaskStepsView.stepView = Marionette.ItemView.extend({
    tagName: "tr",
    template: TaskStepTemplate,
    className: "task-step",
    events: {
      "change .task-step-select-department": function (e) {
        var value = $(e.target).val();
        if (!value) {
          value = 0;
        } else {
          value = +value;
        }
        this.trigger("change:assignee:department", {
          view: this,
          model: this.model,
          value: value,
        });
      },
      "change .task-step-select-user": function (e) {
        var value = $(e.target).val();
        if (!value || value == "all") {
          value = "all";
        } else if (value == "none") {
          value = "none";
        } else {
          value = +value;
        }
        this.trigger("change:assignee:user", {
          view: this,
          model: this.model,
          value: value,
        });
      },
      "input .task-step-instructions-input": function (e) {
        var value = $(e.target).val();
        this.trigger("change:step:instructions", {
          view: this,
          model: this.model,
          value: value,
        });
      },
      "input .task-step-input-can-edit": function (e) {
        var checked = $(e.target).prop("checked");
        this.trigger("change:assignee:canEdit", {
          view: this,
          model: this.model,
          value: checked,
        });
      },
    },
    modelEvents: {
      "change:departmentUsers": "render",
      "change:lastAssignee": "render",
      invalid: "onInvalid",
    },
    triggers: {
      "click .task-step-add-assignee": "add:assignee",
      "click .task-step-remove-assignee": "remove:assignee",
    },
    templateHelpers: {
      getDepartmentName: function () {
        if (this.departmentName) {
          return this.departmentName;
        }
        var departmentId = this.departmentId;
        if (!departmentId) {
          return "";
        }
        var departments = this._thisObject.collection.departments;
        if (!departments) {
          return "";
        }
        var department = departments.get(departmentId);
        if (!department) {
          return "";
        }
        return department.get("name");
      },
      getDepartmentUserName: function () {
        if (this.allUsers) {
          return $.t("task.wizard.allUsers");
        }
        if (this.userName) {
          return this.userName;
        }
        var departmentUsers = this.departmentUsers;
        if (!departmentUsers) {
          return "";
        }
        var departmentUser = _.find(function (u) {
          return u.id == this.userId;
        }, this);
        if (!departmentUser) {
          return "";
        }
        return departmentUser.get("userName");
      },
    },
    ui: {
      taskStepDepartmentError: ".task-step-department-error",
      taskStepInstructionsError: ".task-step-instructions-error",
      taskStepUserError: ".task-step-user-error",
    },
    clearErrors: function () {
      this.ui.taskStepDepartmentError.html("");
      this.ui.taskStepInstructionsError.html("");
      this.ui.taskStepUserError.html("");
    },
    onInvalid: function (model, errors) {
      if (errors.departmentId) {
        this.ui.taskStepDepartmentError
          .html('<h5 class="error-message">' + _.escape(errors.departmentId) + "</h5>")
          .hide()
          .fadeIn();
      } else {
        this.ui.taskStepDepartmentError.html("");
      }
      if (errors.instructions) {
        this.ui.taskStepInstructionsError
          .html('<h5 class="error-message">' + _.escape(errors.instructions) + "</h5>")
          .hide()
          .fadeIn();
      } else {
        this.ui.taskStepInstructionsError.html("");
      }
      if (errors.userId) {
        this.ui.taskStepUserError
          .html('<h5 class="error-message">' + _.escape(errors.userId) + "</h5>")
          .hide()
          .fadeIn();
      } else {
        this.ui.taskStepUserError.html("");
      }
    },
  });

  TaskStepsView.stepsView = Marionette.CompositeView.extend({
    template: TaskStepsTemplate,
    itemView: TaskStepsView.stepView,
    itemViewContainer: "tbody",
    triggers: {
      "click .add-task-step-button": "add:step",
    },
    clearErrors: function () {
      $(".steps-error", this.$el).html("");
      this.children.each(function (childView) {
        childView.clearErrors();
      });
    },
    stepsError: function (message) {
      $(".steps-error", this.$el)
        .html('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },
  });

  return TaskStepsView;
});
